
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-buyers",
      function () {
        return require("private-next-pages/for-buyers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-buyers"])
      });
    }
  